import { useQuery } from "react-query";
import { getRetailStoreOptions } from "../api/officeApplianceService";

export const useGetRetailStoreOptions = () => {
  return useQuery("GetRetailStoreOptions", getRetailStoreOptions, {
    refetchOnWindowFocus: false,
  });
};
